<template>
  <div class="division-4"><div class="text-3 avenirnextltpro-demi-normal-big-stone-19-4px">/</div></div>
</template>

<script>
export default {
  name: "Division2",
};
</script>

<style>
.division-4 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 19.35px;
  padding: 3.87px;
  position: relative;
  width: fit-content;
}

.text-3 {
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
</style>
